<span
  [class]="'size-' + size()"
  [ngStyle]="{ color: textColor() ? textColor() : 'var(--primary-text-color)' }">
  {{ textValue() }}
</span>
